import { AccountBase, Permission, ReportConfiguration, ReportROI, SystemsOfMeasurement, Unionize } from "fond/types";
import { UserTracking } from "fond/types/userTracking";

export type MultiReport = UserTracking & {
  EntityType: "multi_report";
  ID: string;
  Name: string;
  Description: string | null;
  Account: AccountBase;
  MultiProject: { ID: string } | null;
  Folder: { ID: string };
  Permission: Permission | null;
};

export type FullMultiReport = MultiReport & {
  SystemOfMeasurement: SystemsOfMeasurement;
  ReportConfiguration: ReportConfiguration | null;
  Reports: ({ ID: string; Name: string } & ReportROI)[];
};

export const MultiReportCategory = ["Npv", "Irr", "Roi", "CostPerMeter", "CostPerPassing"] as const;
export type MultiReportCategory = Unionize<typeof MultiReportCategory>;
